// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderOutlinedSvg from "@fishx/icons-svg/es/asn/BorderOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderOutlined = function BorderOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderOutlinedSvg
  }));
};

BorderOutlined.displayName = 'BorderOutlined';
export default React.forwardRef(BorderOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderOutlined.js
// module id = 2095
// module chunks = 0